'use client'

import Image from "next/image"

import theme_dark from '@/public/image/theme_dark.png';
import theme_light from '@/public/image/theme_light.png';
import { DeviceContext } from "@/context/deviceContext";
import { useContext } from "react";
import { useTranslations } from "next-intl";

export default function SwitchTheme() {
    const { theme, HandleSelectTheme } = useContext(DeviceContext)

    const t = useTranslations('Text')
    
    return (
        <div className={'theme-switch'}>
            <label className="--pointer">
                <input type="checkbox"
                    name="is_duplicateIP"
                    checked={theme == 'light' ? true : false}
                    onChange={e => HandleSelectTheme(theme == 'light' ? 'dark' : 'light')} />
                <span className={`lever flex center keep-word`}>
                    <span>{t('다크모드')}</span>
                    <span>{t('라이트모드')}</span>
                    {/* <img src={theme_dark.src} />
                    <img src={theme_light.src} /> */}
                </span>
            </label>
        </div>
    )
}